import { render } from "./client-structure-corporate.vue?vue&type=template&id=72947682"
import script from "./client-structure-corporate.vue?vue&type=script&lang=js"
export * from "./client-structure-corporate.vue?vue&type=script&lang=js"

import "./client-structure-corporate.vue?vue&type=style&index=0&id=72947682&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__